import {
  DataTable,
  Paginator,
  SkeletonLoader,
  FilterBar,
  PageActions,
  ExportButton,
  StatusPill,
} from 'components';

import { humanReadable } from 'utils';

import columns from './columns';
import { ListFourUiProps } from './ListFour.types';

function TypeBodyTemplate(row: any) {
  const type: string = row.endorsementtype || '';

  if (!type) return 'N/A';

  return (
    <span className={`colored-circle colored-circle--${type.toLowerCase()}`}>
      {type}
    </span>
  );
}

function StatusBodyTemplate(row: any) {
  return <StatusPill status={row.status} />;
}

function SentDateBodyTemplate(row: any) {
  return humanReadable(row.updated);
}

function CreatedDateBodyTemplate(row: any) {
  return humanReadable(row.created);
}

function UpdatedDateBodyTemplate(row: any) {
  return humanReadable(row.updated);
}

export default function ListFourUi({
  isLoading,
  isExporting,
  totalRecords,
  filter,
  options,
  data,
  handlers,
}: ListFourUiProps) {
  return (
    <div className="az-tickets">
      <PageActions>
        <ExportButton
          disabled={isLoading || !data.list || data.list.length === 0}
          onClick={handlers.handleDownload}
          loading={isExporting}
        />
      </PageActions>

      <FilterBar
        loading={isLoading}
        onReset={handlers.handleClearAllFilters}
        search={{
          inputs: [
            {
              name: 'endorsementId',
              placeholder: 'Endorsement ID',
              value: filter.endorsementId || '',
            },
          ],
          onChange: handlers.handleSearchChange,
          onSubmit: handlers.handleSubmitSearch,
          width: 4,
        }}
        filters={[
          {
            kind: 'dropdown',
            name: 'endorsementType',
            label: 'Endorsement type',
            placeholder: 'All types',
            value: filter.endorsementType || '',
            options: options.endorsementTypes,
            onChange: handlers.handleEndorsementTypeChange,
          },
          {
            kind: 'dropdown',
            name: 'status',
            label: 'Endorsement status',
            placeholder: 'All statuses',
            value: filter.status || '',
            options: options.endorsementStatuses,
            onChange: handlers.handleStatusChange,
          },
        ]}
      />

      {isLoading ? (
        <SkeletonLoader height="10rem" />
      ) : (
        <DataTable
          sortMode="multiple"
          totalRecords={totalRecords}
          columns={columns.map((column) => {
            if (column.field === 'endorsementtype') {
              return {
                ...column,
                body: TypeBodyTemplate,
              };
            }

            if (column.field === 'status') {
              return {
                ...column,
                body: StatusBodyTemplate,
              };
            }

            if (column.field === 'sentdate') {
              return {
                ...column,
                body: SentDateBodyTemplate,
              };
            }

            if (column.field === 'created') {
              return {
                ...column,
                body: CreatedDateBodyTemplate,
              };
            }

            if (column.field === 'updated') {
              return {
                ...column,
                body: UpdatedDateBodyTemplate,
              };
            }

            return {
              ...column,
              body: (row: any) =>
                !row[column.field] ? 'N/A' : row[column.field],
            };
          })}
          value={data.list}
        />
      )}

      {data.list?.length > 0 &&
        (isLoading ? (
          <SkeletonLoader height="3rem" width="40rem" />
        ) : (
          <Paginator
            first={filter.first}
            rows={filter.rows}
            totalRecords={totalRecords}
            rowsPerPageOptions={[10, 50, 100]}
            onPageChange={handlers.handlePageChange}
          />
        ))}
    </div>
  );
}
